import { isBrandSessionView, isAdminView, isShopSessionView, isBarberSessionView, isAgentView, } from './types';
import { persistentKVStore } from '../persistence';
import config from '../../../config';
export var getSessionBrand = function (session) {
    if (isAdminView(session.view) || isAgentView(session.view)) {
        return null;
    }
    if (isBrandSessionView(session.view)) {
        return session.view.viewer;
    }
    return session.view.owners.brand;
};
export var getSessionShop = function (session) {
    if (isAdminView(session.view) || isAgentView(session.view)) {
        return null;
    }
    if (isShopSessionView(session.view)) {
        return session.view.viewer;
    }
    if (isBarberSessionView(session.view)) {
        return session.view.owners.shop;
    }
    return null;
};
// TODO: Shop not defined for brand session view. It needs to be fixed before using this function
export var getActiveCountry = function (session) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (isAdminView(session.view) || isAgentView(session.view)) {
        return null;
    }
    if (isShopSessionView(session.view)) {
        var shop_1 = session.view.viewer;
        return (_b = (_a = shop_1.address) === null || _a === void 0 ? void 0 : _a.country) !== null && _b !== void 0 ? _b : null;
    }
    if (isBarberSessionView(session.view)) {
        var shop_2 = (_c = session.view.owners) === null || _c === void 0 ? void 0 : _c.shop;
        return (_e = (_d = shop_2.address) === null || _d === void 0 ? void 0 : _d.country) !== null && _e !== void 0 ? _e : null;
    }
    var shop = (_f = session.view.viewer.shops) === null || _f === void 0 ? void 0 : _f[0];
    return (_h = (_g = shop === null || shop === void 0 ? void 0 : shop.address) === null || _g === void 0 ? void 0 : _g.country) !== null && _h !== void 0 ? _h : null;
};
export var getViewerIdAndKind = function (session) {
    if (!session) {
        return null;
    }
    if (isAdminView(session.view)) {
        return {
            id: session.user.id,
            kind: 'admin',
        };
    }
    if (isAgentView(session.view)) {
        return {
            id: session.user.id,
            kind: 'agent',
        };
    }
    return {
        id: session.view.viewer.id,
        kind: session.view.kind,
    };
};
export var getIsUserImpersonated = function () {
    return persistentKVStore.hasItem('adminToken');
};
export var getPermissions = function (session) {
    if (isAdminView(session.view) || isAgentView(session.view)) {
        return null;
    }
    return session.view.permissions;
};
export var getTimezone = function (session) {
    if (isAdminView(session.view) || isAgentView(session.view)) {
        return config.defaultTimezone;
    }
    return session.view.meta.timezone;
};
export var getDateFormat = function (session) {
    if (isAdminView(session.view) || isAgentView(session.view)) {
        return config.defaultDateFormat;
    }
    return session.view.meta.dateFormat;
};
export var getActiveViewerName = function (session) {
    if (isAdminView(session.view)) {
        return 'Admin';
    }
    if (isAgentView(session.view)) {
        return 'Agent';
    }
    if (isBrandSessionView(session.view) || isShopSessionView(session.view)) {
        return session.view.viewer.name;
    }
    if (isBarberSessionView(session.view)) {
        return "".concat(session.view.viewer.firstName, " ").concat(session.view.viewer.lastName);
    }
    return 'Unknown';
};
export var getActiveBrandAppIcon = function (session) {
    var _a, _b;
    var brand = getSessionBrand(session);
    return (_b = (_a = brand.extension) === null || _a === void 0 ? void 0 : _a.appIconImage) !== null && _b !== void 0 ? _b : null;
};
export var getActiveBrandPrimaryColor = function (session) {
    var _a, _b;
    var brand = getSessionBrand(session);
    return (_b = (_a = brand.extension) === null || _a === void 0 ? void 0 : _a.primaryColor) !== null && _b !== void 0 ? _b : null;
};
